'use client';
import { jsx } from 'react/jsx-runtime';
import '@digdir/designsystemet-web';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef, useRef } from 'react';
import { useMergeRefs } from '../../utilities/hooks/use-merge-refs/use-merge-refs.js';

/**
 * Field component, used to wrap a form field.
 *
 * @example
 * <Field>
 *   <Label>Kort beskrivelse</Label>
 *   <Field.Description>Beskrivelse</Field.Description>
 *   <Input />
 *   <ValidationMessage>Feilmelding</ValidationMessage>
 * </Field>
 */
const Field = forwardRef(function Field({ className, position, asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'ds-field';
    const fieldRef = useRef(null);
    const mergedRefs = useMergeRefs([fieldRef, ref]);
    return (jsx(Component, { ...(asChild
            ? { className: cl('ds-field', className) }
            : { class: cl('ds-field', className) }), suppressHydrationWarning // Since <ds-field> adds attributes
        : true, "data-position": position, ref: mergedRefs, ...rest }));
});

export { Field };
